// import { store } from '../store';
// import * as Core from '../store/core';
export var getDisplayName = function (key, label, method) {
    // const appState = store.getState();
    // const appDispatch = store.dispatch;
    if (label === undefined)
        return;
    var translationKey = "".concat(key).concat(label.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, ''));
    var labelTranslation = method(translationKey);
    if (labelTranslation === translationKey) {
        // appDispatch(
        //     Core.error({
        //         message: `Missing translation for ${label} in ${appState.core?.locale}`,
        //         context: {
        //             type: 'log',
        //             location: `Expected key: ${key}`,
        //         },
        //     }),
        // );
        return label;
    }
    else {
        return labelTranslation;
    }
};
